import { createActionHandler, createReducer } from '@pressreader/appstore';
import { IDeviceInfo, IScreenInfo } from '@pressreader/ui-types';
import { readDeviceInfo } from '@pressreader/utils';

import { computeScreenInfo } from '../utils';

import { clearScreenReaderNotificationAction, deviceInfoLoaded, screenChanged, screenReaderNotified } from './actions';

interface IState {
    // Overridable source of truth for form-factor — seeded from the static UA device flags,
    // replaceable via deviceInfoLoaded (e.g. config-driven "force web view by siteID").
    device: IDeviceInfo;
    screen: IScreenInfo;

    notification: { id: number; message: string } | null;
}

const initialState = ((): IState => {
    return {
        device: readDeviceInfo(),
        screen: computeScreenInfo(),
        notification: null,
    };
})();

const reducer = createReducer(
    initialState,
    createActionHandler(deviceInfoLoaded, (state, action) => ({
        ...state,
        device: action.payload.device,
    })),
    createActionHandler(screenChanged, (state, action) => ({
        ...state,
        screen: {
            ...action.payload.screen,
        },
    })),
    createActionHandler(screenReaderNotified, (state, action) => ({
        ...state,
        notification: {
            id: (state.notification?.id || 0) + 1,
            message: action.payload.message,
        },
    })),
    createActionHandler(clearScreenReaderNotificationAction, state => ({
        ...state,
        notification: null,
    })),
);

export { IState, reducer };
